// removed by extract-text-webpack-plugin
module.exports = {"root":"_2pKH_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/Icon.css
// module id = 563
// module chunks = 0